<template>
  <div class="c-register">
    <div class="logo-bar">
      <img src="@/assets/img/logo-scm.png" />
    </div>

    <div class="main-body">
      <div>
        <van-form class="content-form">
          <div class="logo-bear">
            <div class="bear-icon"><img :src="urlOfBear" /></div>
          </div>
          <h1>注册账号</h1>

          <van-field
            label="公司名称"
            v-model="editItem.Remark"
            placeholder="公司 (必填)"
          />
          <van-field
            label="联系人"
            v-model="editItem.RealName"
            placeholder="**先生/女士"
          />
          <van-field
            label="手机号码"
            v-model="editItem.Mobile"
            placeholder="手机 (必填)"
          />
          <div class="btn_group">
            <div>
              <van-field
                label="图文验证码"
                v-model="imgUrlData"
                placeholder="图文验证码(必填)"
              />
            </div>
            <div>
              <img @click="onLoadCaptcha" :src="CaptchaUrl" />
            </div>
          </div>

          <div class="btn_group">
            <div>
              <van-field
                label="手机验证码"
                v-model="editItem.Captcha"
                placeholder="手机验证码(必填)"
              />
            </div>
            <div>
              <van-button @click="getImgAuthS" size="small">
                获取验证码
              </van-button>
            </div>
          </div>

          <van-field
            label="密码"
            ref="password"
            v-model="editItem.Password"
            placeholder="密码 (必填)"
            type="password"
            autoComplete="new-password"
            @blur="focusInPassword = false"
            @focus="focusInPassword = true"
          />
          <!-- <span class="toggle-btn" @click="onToggleErpPassword">
              <svg-icon
                :icon-class="
                  PasswordInputType === 'password' ? 'eye' : 'eye-open'
                "
              />
            </span> -->

          <div class="btns">
            <van-button size="normal" type="info" @click="onRegister">
              立即注册
            </van-button>
          </div>
          <div class="text-to-login">
            已有账号？<router-link to="/login">马上登录</router-link>
          </div>
          <p class="registerNew_phone">注册咨询: 0755-82798001</p>
        </van-form>
      </div>
    </div>
    <div class="content_footer">
      ©{{ new Date().getFullYear() }} 深圳市正能量供应链服务有限公司 <br />
      粤ICP备19017994号-1
    </div>
  </div>
</template>

<script>
import { Dialog, Form as VanForm, Toast } from "vant";
// import { mixin as common } from "~assets/scripts/methods/common";

// import { getCookie, getDays, setCookie } from "~assets/scripts/utils/urls";
import * as captchaService from "~/services/captchaService";
import * as UserApi from "@/api/user";
import { loadUser } from "~/services/UserService";

// const Config = {
//   SignUp: "/User/SignUp",
//   SendRegisterSms: "/FrontUser/SendRegisterSms",
//   Captcha: "Captcha/GetId",
//   CaptchaImg: "Captcha/GetImage",
// };
const bear_def = require("~/images/login/normal.png");
const bear_close_eyes = require("~/images/login/blindfold.png");

export default {
  components: { VanForm },
  name: "",
  // mixins: [common],
  data() {
    return {
      editItem: {
        Mobile: "",
        Password: "",
        Captcha: "",
        Remark: "",
        RealName: "",
      },
      urlOfBear: bear_def,
      CaptchaUrl: "",
      imgUrlData: "",
      PasswordInputType: "password",
      focusInPassword: false,
    };
  },
  watch: {
    focusInPassword: {
      immediate: true,
      handler(v) {
        this.urlOfBear = v ? bear_close_eyes : bear_def;
      },
    },
  },
  methods: {
    // 1.验证数据
    configData() {
      let err = "";
      let { Mobile, Password, Remark } = this.editItem;
      if (String.isNullOrEmpty(Mobile)) {
        err = "请输入手机号";
      } else if (String.isNullOrEmpty(Password)) {
        err = "请输入密码";
      } else if (String.isNullOrEmpty(Remark)) {
        err = "请输入公司";
      }
      return err;
    },

    // 2.获取验证码
    async getImgAuthS() {
      let imgUrlData = this.imgUrlData;
      let err = "";
      if (!String.isMobile(this.editItem.Mobile)) {
        err = "请输入正确的手机号";
      } else if (!imgUrlData) {
        err = "请先输入图文验证码";
      }

      if (err) {
        Toast.fail(err);
        return false;
      }

      const captchaId = await captchaService.getCaptchaId();
      let params = {
        Mobile: this.editItem.Mobile,
        CaptchaId: captchaId,
        Captcha: this.imgUrlData,
      };
      UserApi.sendRegisterSms(params)
        .then(() => {
          Toast.success({ message: "验证码已发送" });
        })
        .catch(this.onLoadCaptcha);
    },

    // 注册
    async onRegister() {
      var keys = Object.keys(this.$route.query);

      var code, PromoCodeSetId;

      keys.forEach((e) => {
        switch (e.toLowerCase()) {
          case "pcode":
            code = this.$route.query[e];
            break;
          case "promocodesetid":
            PromoCodeSetId = this.$route.query[e];
            break;
        }
      });

      let err = this.configData();
      if (err) {
        Toast.fail(err);
        return false;
      }

      if (code) {
        this.editItem.PCode = code;
        this.editItem.PromoCodeSetId = PromoCodeSetId;
      }
      let data = await UserApi.signUp(this.editItem); // this.$post(Config.SignUp, this.editItem);

      // 用户绑定微信
      if (data.WeChatSetupToken) {
        console.log("用户绑定微信");
        // this.$router.push({
        //   name: "UserWeChatSetup",
        //   query: {
        //     code: data.WeChatSetupToken,
        //   },
        // });
        // return;
      }
      Dialog.alert({
        message:
          "注册成功，感谢您的信任，将有工作人员于两个工作日内和您电话沟通。我司客服电话 0755-82798001，如有需要可电话垂询，谢谢~",
      });
      await loadUser();
      this.$router.push({ path: "/" });
    },

    // 图片验证码
    async onLoadCaptcha() {
      this.CaptchaUrl = await captchaService.getImageUrl();
    },
  },

  async created() {
    await this.onLoadCaptcha();
  },
};
</script>

<style lang="scss">
.c-register {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: url("../../images/login/login_bng.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  width: 100%;
  .van-cell::after {
    display: none;
  }
  .van-cell {
    border-bottom: 1px solid #eee;
  }
  .van-field__label {
    text-align: right;
    span::after {
      content: "：";
    }
  }

  .main-body {
    flex: auto;
    display: flex;
    align-items: center;
    width: 100%;
    > div {
      width: 100%;
    }
  }
  .logo-bear {
    position: relative;
    width: 0.8rem;
    margin: 0 auto;
    height: 0.2rem;
    .bear-icon {
      position: absolute;
      bottom: 0;
    }
    img {
      width: 0.8rem;
    }
  }

  h1 {
    font-size: 0.14rem;
    margin: 0.1rem auto;
    margin-top: 0.05rem;
    text-align: center;
    border-bottom: 0.02rem brown solid;
    padding-bottom: 0.05rem;
    width: 6em;
  }
  .logo-bar {
    background-color: #fff;
    padding: 0.05rem;
    img {
      height: 0.35rem;
    }
  }
  .content-form {
    margin: 0.1rem;
    background-color: #fff;
    flex: auto;
    border-radius: 0.08rem;
  }
  .text-to-login {
    margin: 0.05rem auto;
    width: 80%;
    text-align: right;
  }
  .btn_group {
    display: flex;
    align-items: center;

    > div:first-child {
      flex: auto;
    }
    > div:last-child {
      width: 1.1rem;
      text-align: center;
    }
    img {
      width: 100%;
      max-width: 130px;
    }
  }
  .btns {
    text-align: center;
    margin-top: 0.1rem;
    button {
      width: 80%;
    }
  }
  .registerNew_phone {
    font-size: 0.14rem;
    line-height: 0.5rem;
    text-align: center;
  }
  .content_footer {
    padding: 0.5em 0;
    text-align: center;
    color: #fff;
    background-color: #fff4;
  }
}
</style>
